import { useMutation } from '@tanstack/react-query'
import { getPromotionInfo } from '../../../service/point'

function useGetPromotion() {
  return useMutation({
    mutationKey: ['get-promotion'],
    mutationFn: getPromotionInfo,
  })
}

export default useGetPromotion
